// ----------------------------------------------------------------------

export default function Tooltip() {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff9cb',
          color: '#000000',
        },
        arrow: {
          color: '#fff9cb',
        },
      },
    },
  };
}
